// extracted by mini-css-extract-plugin
export default {"m":"d1b997d080","title":"_4f52fdf2b3","feedback_inner_title":"_2fb06557ac","textarea":"_1c623ddf8d","radio":"_6338c4261e","text":"_0f80bccc3f"};